export enum DateFormulaType {
  Date = 'Date',
  Terms = 'Terms'
}
